// jQuery pOptions - pseudo options
// *disable-eslint*

/* eslint-disable */
(function ($) {
  'use strict';

  $.pOptions = function (element, options) {

    var defaults = {
      disabled: false
    };

    var plugin = this;

    plugin.settings = {};

    plugin.is_open = false;
    plugin.value = [];

    plugin.element = $(element);
    plugin.wrapper = $('.poptions__wrapper', plugin.element);

    plugin.init = function () {
      plugin.settings = $.extend({}, defaults, options);

      // Initialize Settings
      if (plugin.settings.disabled) {
        plugin.disable();
      }

      if (plugin.settings.default) {
        plugin.initialSelect();
      }

      // Show select options
      $('.poptions__display-value', plugin.element).on('click', function (e) {
        plugin.toggle(null);
        e.preventDefault();
      });

      // Clear selection
      $('.poptions__clear', plugin.element).on('click', function (e) {
        plugin.clear();

        e.preventDefault();
      });

      // Make selection
      $('input[type=\'checkbox\']', plugin.element).on('change', function (e) {
        if(this.checked) {
          plugin.select($(this));
        }
        else {
          plugin.unselect($(this));
        }
      });

      // hiding the result list when anything else except selectIt components is clicked
      $(document).click(function (event) {
        if (plugin.is_open && !$(event.target).is(plugin.element) && !$(event.target).parents().is(plugin.element)) {
          plugin.toggle(false);
        }
      });


      // Add Keyboard Accessibility
      // Keycodes
      var spaceBarKeyCode = [0, 32];
      var enterKeyCode = 13;
      var downArrowKeyCode = 40;
      var upArrowKeyCode = 38;
      var escapeKeyCode = 27;
      var tabKeyCode = 9;
      var listItems;

      function selectFirstItem(element) {
        //Change tab order for first item in list
        var firstItem = $(element).next().find('.poptions__option').first();
        var items = $(element).next().find('.poptions__option');
        $(firstItem).focus();
        $(items).attr('tabindex', 0);
      }

      function leavePoptions(element) {
        var items = $(element).next().find('.poptions__option');
        $(items).attr('tabindex', -1);
      }

      $('.poptions__display-value', plugin.element).on('keydown', function (e) {
        if ($('.poptions__display-value', plugin.element).is(':focus')) {
          switch (e.keyCode) {
            case downArrowKeyCode:
              selectFirstItem($(this));
              plugin.toggle(open);
              e.preventDefault();
              break;
            case enterKeyCode:
              e.preventDefault();
              break;
          }
          return;
        }
      });

      $('.poptions__option', plugin.element).on('keydown', function (e) {
        if ($('.poptions__option', plugin.element).is(':focus')) {
          switch (e.keyCode) {
            case downArrowKeyCode:
              $(this).next().focus();
              break;
            case upArrowKeyCode:
              $(this).prev().focus();
              break;
            case tabKeyCode:
              e.preventDefault();
              break;
            case enterKeyCode:
              $(this).find('input').trigger('click');
              break;
            case escapeKeyCode:
              $(this).closest('.poptions__options').prev().focus();
              plugin.toggle(false);
              leavePoptions($(this).closest('.poptions__options').prev());
              break;
          }
        }
      });

    };

    plugin.toggle = function (open) {
      // If null, set open to opposite of current state (to toggle).
      if (open === null) {
        open = !plugin.is_open;
      }

      if (open) {
        plugin.is_open = true;
        plugin.wrapper.addClass('active');
        // Event handler.
        if (typeof plugin.settings.onOpen !== 'undefined') {
          plugin.settings.onOpen();
        }
      }
      else {
        plugin.is_open = false;
        plugin.wrapper.removeClass('active');
        // Event handler.
        if (typeof plugin.settings.onClose !== 'undefined') {
          plugin.settings.onClose();
        }
      }
    };

    plugin.enable = function () {
      plugin.settings.disabled = false;
      plugin.wrapper.removeClass('disabled');
      // Event handler.
      if (typeof plugin.settings.onEnable !== 'undefined') {
        plugin.settings.onEnable();
      }
    };

    plugin.disable = function () {
      plugin.settings.disabled = true;
      plugin.wrapper.addClass('disabled');
      // Event handler.
      if (typeof plugin.settings.onDisable !== 'undefined') {
        plugin.settings.onDisable();
      }
    };

    plugin.select = function (option, noCallback) {
      if (plugin.settings.disabled) {
        plugin.enable();
      }

      plugin.setValue(option.attr('name'), option.attr('value'));

      // Make sure the option shows it's selected.
      option.prop('checked', true);

      // Track that the clear should show.
      $('.poptions__clear', plugin.element).addClass('active');

      // Event handler.
      if (!noCallback && typeof plugin.settings.onChange !== 'undefined') {
        plugin.settings.onChange(option);
      }
    };

    plugin.unselect = function (option, noCallback) {
      if (plugin.settings.disabled) {
        plugin.enable();
      }

      plugin.unsetValue(option.attr('name'), option.attr('value'));

      // Make sure the option shows it's unselected.
      option.prop('checked', false);

      // Track that the clear should show.
      if (plugin.isValueEmpty()) {
        $('.poptions__clear', plugin.element).removeClass('active');
      }

      // Event handler.
      if (!noCallback && typeof plugin.settings.onChange !== 'undefined') {
        plugin.settings.onChange(option);
      }
    };

    plugin.initialSelect = function (noCallback) {
      // Run through values to set initial options.
      var values = plugin.settings.default;
      for (var name in values) {
        if (values.hasOwnProperty(name)) {
          // Reset value to array if it isn't one already
          if (!Array.isArray(values[name])) {
            values[name] = [values[name]];
          }

          // Check each initial value.
          for (var index in values[name]) {
            if (values[name].hasOwnProperty(index)) {
              var option = plugin.getOption(name, values[name][index]);
              if (option.length > 0) {
                plugin.select(option);
              }
            }
          }
        }
      }

      // Event handler.
      if (!noCallback && typeof plugin.settings.onInitialSelect !== 'undefined') {
        plugin.settings.onInitialSelect(plugin.settings.default);
      }
    };

    plugin.setValue = function (name, value) {
      // Make sure that the current name set is being tracked.
      if (!plugin.value.hasOwnProperty(name)) {
        plugin.value[name] = [];
      }

      // Add value to array of values if not already there.
      if (plugin.value[name].indexOf(value) === -1) {
        plugin.value[name].push(value);
      }
    };

    plugin.unsetValue = function (name, value) {
      // Make sure that the current name set is being tracked.
      if(!plugin.value.hasOwnProperty(name)) {
        plugin.value[name] = [];
      }

      // Remove value from array if value is there.
      var valueIndex = plugin.value[name].indexOf(value);
      if (valueIndex !== -1) {
        plugin.value[name].splice(valueIndex, 1);
      }
    };

    plugin.isValueEmpty = function () {
      // Run through each group and option.
      for (var name in plugin.value) {
        if (plugin.value.hasOwnProperty(name)) {
          for (var index in plugin.value[name]) {
            if (plugin.value[name].hasOwnProperty(index)) {
              return false;
            }
          }
        }
      }

      // Return true if no values are hit.
      return true;
    };

    plugin.clear = function (noCallback) {
      $('.poptions__clear', plugin.element).removeClass('active');

      // Wipe values array.
      plugin.value = [];

      // Uncheck all inputs.
      $('input', plugin.element).prop('checked', false);

      // Event handler.
      if (!noCallback && typeof plugin.settings.onClear !== 'undefined') {
        plugin.settings.onClear(plugin);
      }
    };

    plugin.getOption = function (name, value) {
      return plugin.element.find('input[name="' + name +'"][value="' + value +'"]');
    };
  };

  $.fn.pOptions = function (options) {
    return this.each(function () {
      // Check if there is an existing instance related to element.
      var instance = $.data(this, 'pOptions');

      if (instance) {
        return instance;
      } else {
        // Create the plugin.
        var plugin = new $.pOptions(this, options);

        // Store the plugin instance on the element.
        $.data(this, 'pOptions', plugin);

        plugin.init();
        return plugin;
      }
    });
  };

})(jQuery);
